export default __webpack_public_path__ + "static/media/card-options.cae61cee.png";